module.exports = __webpack_public_path__ + "img/btn_color.eb27b845.svg";